<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div id="registroForm" [ngClass]="{'d-none': recoverform}">
            <div class="logo">
                <span class="db"><img src="assets/images/netHome/vidaDigital.png" width="100%" height="100%" alt="logo" /></span>
            </div>
            <!-- Form -->
            <div class="row">
                <div class="col-12">

                    <form (ngSubmit)="registro(registroForm)" #registroForm="ngForm" class="form-horizontal m-t-20" id="registroForm">

                        <div class="form-body">
                            <div class="form-group text-center">
                                <h3 class="font-medium ">Creación de un nuevo Usuario</h3>
                            </div>
                            <div class="input-group mb-1">
                                <label>Registo Federal De Causantes del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && rfcUsuario.invalid}" autofocus name="rfcUsuario" [(ngModel)]="usuario.rfcUsuario" #rfcUsuario="ngModel" autofocus required minlength="12" maxlength='13' type="text" class="form-control form-control-sm"
                                    aria-describedby="basic-addon1">
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && rfcUsuario.invalid && rfcUsuario?.errors.required">
                                    <b>El rfc es requerido</b>
                                </div>
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && rfcUsuario.invalid && rfcUsuario?.errors.minlength">
                                    <b>El Registo Federal De Causantes del Usuario debe tener al menos 12 caracteres</b>
                                </div>
                            </div>
                            <div class="input-group mb-1">
                                <label>Nombre completo del Usuario </label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && nombre.invalid}" name="nombre" [(ngModel)]="usuario.nombre" required #nombre="ngModel" type="text" class="form-control form-control-sm" aria-describedby="basic-addon1">
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && nombre.invalid && nombre?.errors.required">
                                    <b>El Nombre completo del Usuario es requerido</b>
                                </div>
                            </div>
                            <div class="input-group mb-1">
                                <label>Correo electrónico del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && correo.invalid}" name="phone" [(ngModel)]="usuario.correo" required #correo="ngModel" type="text" class="form-control form-control-sm" aria-describedby="basic-addon1">
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && correo.invalid && correo?.errors.required">
                                    <b>Correo electrónico del Usuario</b>
                                </div>
                            </div>

                            <div class="input-group mb-1">
                                <label>Teléfono del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && phone.invalid}" name="phone" [(ngModel)]="usuario.phone" required #phone="ngModel" type="text" class="form-control form-control-sm" aria-describedby="basic-addon1">
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && phone.invalid && phone?.errors.required">
                                    <b>Teléfono del Usuario</b>
                                </div>
                            </div>

                            <div class="input-group mb-1">
                                <label>Domicilio Del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <div class="input-group">
                                    <input id="domiciliousuario" disabled required name="domiciliousuario" type="text" class="form-control" required [(ngModel)]="usuario.direccion" #domiciliousuario="ngModel">
                                    <div class="input-group-append">
                                        <button class="btn btn-block btn-success" type="button" (click)="openVerticallyCentered(content)">Generar</button>
                                    </div>
                                </div>
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && correo.invalid && correo?.errors.required">
                                    <b>El domicilio es requerido</b>
                                </div>
                            </div>

                            <div class="input-group mb-1">
                                <label>Nacionalidad del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <div class="input-group mb-1">
                                    <select class="form-select" name="nacionalidadInput" [value]="nacionalidadInput" [(ngModel)]="usuario.nacionalidad" id="nacionalidadInput" #nacionalidadInput aria-describedby="basic-addon1">
                                        <option *ngFor="let nacion of nacionalidades" value = "{{nacion}}">{{nacion}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-group mb-1">
                                <label>Contraseña del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && contrasena.invalid}" name="contrasena" [(ngModel)]="usuario.contrasena" required #contrasena="ngModel" [type]="showPassword ? 'text' : 'password'" class="form-control form-control-sm" aria-describedby="basic-addon1">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" (click)="togglePasswordVisibility()">
                                        <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </button>
                                </div>
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && contrasena.invalid && contrasena?.errors.required">
                                    <b>La Contraseña del Usuario es requerida</b>
                                </div>
                            </div>
                            <div class="input-group mb-1">
                                <label>Confirma la contraseña del Usuario</label>
                            </div>
                            <div class="input-group mb-1">
                                <input [ngClass]="{'is-invalid': registroForm.submitted && contrasenaConfirmacion.invalid}" name="contrasenaConfirmacion" [(ngModel)]="usuario.contrasenaConfirmacion" required #contrasenaConfirmacion="ngModel" [type]="showConfirmPassword ? 'text' : 'password'" class="form-control form-control-sm"
                                    aria-describedby="basic-addon1">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" (click)="toggleConfirmPasswordVisibility()">
                                        <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </button>
                                </div>
                                <div class="invalid-feedback" *ngIf="registroForm.submitted && contrasenaConfirmacion.invalid && contrasenaConfirmacion?.errors.required">
                                    <b>La confirmacion de contraseña del Usuario es requerida</b>
                                </div>
                            </div>
                            <div class="input-group mb-1">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="terms_accept" id="termsCheckbox" name="termsCheckbox">
                                <label for="termsCheckbox" style="padding-left: 8px;"> Acepto <a href="https://tuvida.digital/terminos-y-condiciones/" target="_blank">Terminos y Condiciones</a></label>
                            </div>
                            <div class="input-group mb-1">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="privacy_accept" id="privacyCheckbox" name="privacyCheckbox">
                                <label for="privacyCheckbox" style="padding-left: 8px;"> Acepto <a href="https://tuvida.digital/aviso-de-privacidad/" target="_blank">Aviso de Privacidad</a></label>
                            </div>
                            
                            <div class="form-group text-center">
                                <div class="col-xs-12 ">
                                    
                                    <button class="btn btn-success" type="submit" [disabled]="!terms_accept || !privacy_accept">Crear usuario</button>
                                    
                                </div>
                            </div>
                            <div class="form-group mb-1">
                                <div class="col-sm-12 text-center ">
                                    ¿Ya tienes una cuenta? <a href="#/login/registro" class="text-success  m-l-5 "><b>Ingresa</b></a>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>




            <!--div class="row">
                <div class="col-12">
                    <form class="form-horizontal m-t-20" action="index.html">
                        <div class="form-group row ">
                            <div class="col-12 ">
                                <input class="form-control form-control-lg" type="text" required=" " placeholder="Name">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 ">
                                <input class="form-control form-control-lg" type="text" required=" " placeholder="Email">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 ">
                                <input class="form-control form-control-lg" type="password" required=" " placeholder="Password">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 ">
                                <input class="form-control form-control-lg" type="password" required=" " placeholder="Confirm Password">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12 ">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">Yo Acepto Los <a href="https://tuvida.digital/terminos-y-condiciones/" target="_blank">Terminos Y Condiciones</a></label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center ">
                            <div class="col-xs-12 p-b-20 ">
                                <button class="btn btn-block btn-lg btn-info " type="submit ">Crear</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div-->

            <ng-template #content let-c="close" let-d="dismiss">
                <div class="modal-header">
                    <h4 class="modal-title">Generación Del Domicilio</h4>
                </div>
                <div class="modal-body">
                    <form class="form">
                        <div class="card-body">
                            <div class="form-group row">
                                <span class="col-4 input-group-text">Código Postal</span>
                                <div class="col-8 input-group">
                                    <input class="form-control" id="codigoPostal" name="codigoPostal" type="number" [(ngModel)]="codigo.codigoPostal" #codigoPostal="ngModel">
                                    <div class="input-group-append">
                                        <button class="btn btn-block btn-success" (click)="metodoModal() ">Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Colonia</span>
                                <div class="col-8">
                                    <select class="form-select" name="coloniaSociedadInput" [value]="coloniaSociedadInput" [(ngModel)]="codigo.coloniaSeleccion" id="coloniaSociedadInput" #coloniaSociedadInput>
                                    <option *ngFor="let colonia of codigo.colonia" value ="{{colonia}}">{{colonia}}</option>
                                </select>
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Municipio / Alcaldía</span>
                                <div class="col-8">
                                    <select class="form-select" name="municipioSociedadInput" [value]="municipioSociedadInput" [(ngModel)]="codigo.municipioSeleccion" id="municipioSociedadInput" #municipioSociedadInput>
                                        <option *ngFor="let municipio of codigo.municipio" value = "{{municipio}}">{{municipio}}</option>
                                    </select>
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Estado</span>
                                <div class="col-8">
                                    <select class="form-select" name="estadoSociedadInput" [value]="estadoSociedadInput" [(ngModel)]="codigo.estadoSeleccion" id="estadoSociedadInput" #estadoSociedadInput>
                                    <option *ngFor="let estado of codigo.estado" value = "{{estado}}">{{estado}}</option>
                                </select>
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Calle o Avenida</span>
                                <div class="col-8">
                                    <input type="text" name="calleSociedad" [(ngModel)]="codigo.calle" class="form-control" id="calleSociedad" #calleSociedad="ngModel">
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Número #</span>
                                <div class="col-8">
                                    <input type="text" name="numeroSociedad" [(ngModel)]="codigo.numeroExterior" class="form-control" id="numeroSociedad" #numeroSociedad="ngModel">
                                </div>
                            </div>
                            <div *ngIf="datosDomicilio" class="form-group row">
                                <span class="col-4 input-group-text">Número Interior #</span>
                                <div class="col-8">
                                    <input type="text" name="numeroInteriorSociedad" [(ngModel)]="codigo.numeroInterior" class="form-control" id="numeroInteriorSociedad" #numeroInteriorSociedad="ngModel">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer btn-group-sm">
                    <button type="button" class="btn btn-success" (click)="crearDomicilioSociedad()">Agregar</button>
                    <button type="button" class="btn btn-danger" (click)="closeModal()">Cerrar</button>
                </div>
            </ng-template>

        </div>
    </div>
</div>
